.searchBlock {
    margin: auto;
    width: max-content;
}

.title {
    font-size: 36px;
    font-weight: 600;
    text-align: center;
}

.searchBar {
    width: 100%;
    margin: 8px 0;

    position: relative;
}

.searchInput {
    width: 100%;
    margin: 0;
    padding-right: 50px;
}

.searchButton {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f2f2f2;

    position: absolute;
    top: 1px;
    right: 1px;

    height: 43px;
    width: 45px;

    border: 0;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;

    cursor: pointer;

    &:focus-visible {
        box-shadow: 0 0 0 4px #a6bdee;
    }
}

@media all and (max-width: 576px) {
    .title {
        font-size: 32px;
    }

    .filterBlock {
        display: flex;
        flex-direction: column;
    }
}